import React from "react"
import { getOrdinal } from "../../utils/get-ordinal"
import { SvgPiechartOneQuarter } from "../icons"

interface Props {
  serviceValues: any
  serviceType: any
}

const FlexPaymentsPreview: React.FC<Props> = ({
  serviceValues,
  serviceType,
}) => {
  const isBundle = serviceType === "bundle"

  const billingSource = isBundle
    ? serviceValues?.package
    : serviceValues?.billing

  const installmentIncrements = billingSource?.installmentIncrements || []

  const totalAmount = isBundle
    ? serviceValues?.package?.packageCost
    : serviceValues?.sessionCost

  const getFirstInstallmentAmount = () => {
    const upFrontPercentage = billingSource?.upFrontPercentage / 100
    return ((totalAmount || 0) * upFrontPercentage).toFixed(2)
  }

  const getSubsequentInstallmentAmount = () => {
    const firstInstallmentAmount = parseFloat(getFirstInstallmentAmount())
    const numberInstallments = billingSource?.installmentIncrements?.length || 0

    if (!numberInstallments) return "0.00"

    const remainingAmount =
      parseFloat(totalAmount || 0) -
      parseFloat(firstInstallmentAmount.toFixed(2))

    return (remainingAmount / numberInstallments).toFixed(2)
  }

  const decodeUnicodeSymbol = (unicodeStr: string | undefined | null) => {
    if (!unicodeStr) {
      return ""
    }
    return unicodeStr.replace(/\\u([\dA-F]{4})/gi, (match, grp) => {
      return String.fromCharCode(parseInt(grp, 16))
    })
  }
  return (
    <>
      <div className="">
        <div className="flex flex-col lg:flex-row w-full gap-[32px]">
          {serviceValues.payment_term !== "installment" && (
            <>
              <div className="flex-1 flex flex-col p-[20px] border rounded-xl">
                <p className="text-graySlate mb-[16px] text-base">
                  Payment In Full
                </p>

                <div className="mb-[16px] flex w-full items-center justify-between">
                  <div className="flex min-w-fit items-center gap-[16px]">
                    <div className="bg-blurple flex h-[24px] w-[24px] items-center justify-center rounded-full font-bold text-white">
                      $
                    </div>
                    <p className="text-[16px]">Payment at checkout</p>
                  </div>

                  <div className="border-grayCloud mx-[16px] h-2 w-[30%] -translate-y-1 transform border-b border-dashed"></div>

                  <span className="text-base">
                    {decodeUnicodeSymbol(serviceValues.symbol)}
                    {Number(totalAmount || 0).toFixed(2)}
                  </span>
                </div>

                <p className="text-graySlate text-base">
                  * Payment will be charged{" "}
                  <strong className="text-black">immediately</strong> at
                  checkout.
                </p>
              </div>

              <div className="flex lg:flex-col items-center justify-center gap-2">
                <div className="flex lg:hidden items-center w-full">
                  <div className="flex-grow h-px bg-grayMist"></div>
                  <span className="px-4 text-graySlate text-sm font-medium">
                    OR
                  </span>
                  <div className="flex-grow h-px bg-grayMist"></div>
                </div>

                <div className="hidden lg:flex flex-col items-center justify-center">
                  <div className="h-[80px] w-px bg-grayMist"></div>
                  <span className="py-2 text-graySlate text-sm font-medium">
                    OR
                  </span>
                  <div className="h-[80px] w-px bg-grayMist"></div>
                </div>
              </div>
            </>
          )}

          <div className="flex-1 flex flex-col p-[20px] border rounded-xl bg-grayMist/40 mb-24 sm:mb-2">
            <p className="text-graySlate mb-[16px] text-base">
              Pay In Installments
            </p>

            <div className="mb-[16px] flex w-full items-center justify-between">
              <div className="flex min-w-fit items-center gap-[16px]">
                <SvgPiechartOneQuarter />
                <p className="text-[16px]">Payment at booking</p>
              </div>

              <div className="border-grayCloud mx-[16px] h-2 w-[30%] -translate-y-1 transform border-b border-dashed"></div>

              <span className="text-base">${getFirstInstallmentAmount()}</span>
            </div>

            {installmentIncrements.length > 0 &&
              installmentIncrements.map((installment: any, index: number) => (
                <div
                  key={index}
                  className="mb-[16px] flex w-full items-center justify-between"
                >
                  <div className="flex min-w-fit items-center gap-[16px]">
                    <SvgPiechartOneQuarter />
                    <p className="text-[16px]">
                      {getOrdinal(index + 1)} installment {installment.time}{" "}
                      {installment.time > 1
                        ? installment.type
                        : installment.type.replace(/s$/, "")}{" "}
                      later
                    </p>
                  </div>

                  <div className="border-grayCloud mx-[16px] h-2 w-[30%] -translate-y-1 transform border-b border-dashed"></div>
                  <span className="text-base">
                    ${getSubsequentInstallmentAmount()}
                  </span>
                </div>
              ))}

            <p className="text-graySlate mb-[6px] text-base">
              * Future payments will be charged according to{" "}
              <strong className="text-black">
                the schedule outlined above
              </strong>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default FlexPaymentsPreview
